var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeDart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_107_2",
    "data-name": "Component 107 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.704,
    height: 128.691,
    viewBox: "0 0 128.704 128.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45798",
    "data-name": "Rectangle 45798",
    width: 128.704,
    height: 128.691,
    fill: "#111c44"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112326",
    "data-name": "Group 112326",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112129",
    "data-name": "Group 112129",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52906",
    "data-name": "Path 52906",
    d: "M56.314,122.343c-2.178-.329-4.369-.612-6.54-.987a58.107,58.107,0,0,1-26.4-11.791A58.429,58.429,0,0,1,1.2,73.628C-2.554,53.448,2.48,35.538,16.428,20.366A57.9,57.9,0,0,1,48.767,2.357,59.9,59.9,0,0,1,92.1,9.976a1.578,1.578,0,0,1,.941,1.678c-.27,4.053-.447,8.113-.724,12.166a2.9,2.9,0,0,1-.73,1.619c-1.323,1.454-2.731,2.829-4.191,4.316-.447-.309-.809-.566-1.171-.816A48.059,48.059,0,0,0,64.164,19.6,39.627,39.627,0,0,0,37.707,25.32,41.384,41.384,0,0,0,17.429,56.9a43.428,43.428,0,0,0,83.226,21.647c.546-1.316,1.033-2.658,1.448-4.02,4.408-14.455,1.54-27.516-8.461-38.932-.217-.25-.428-.5-.743-.869,1.487-1.467,2.928-2.915,4.4-4.323a1.513,1.513,0,0,1,.9-.342c4.3-.257,8.606-.513,12.916-.691a1.752,1.752,0,0,1,1.184.829A58.323,58.323,0,0,1,120.169,50.8a58.6,58.6,0,0,1-5.764,38.721,59.364,59.364,0,0,1-42.879,31.819c-2.2.434-4.441.678-6.659,1.007Z",
    transform: "translate(0.001 6.348)",
    fill: "#111c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52907",
    "data-name": "Path 52907",
    d: "M43.893,14.574c-4.171,4.171-8.336,8.363-12.547,12.495a3.112,3.112,0,0,1-1.816.829c-4.711.336-9.429.592-14.232.875a7.067,7.067,0,0,1-.1-.915c.257-4.593.513-9.185.8-13.784a1.861,1.861,0,0,1,.408-1.112C20.667,8.646,24.963,4.362,29.325,0c.362.336.7.625,1.007.941Q36.6,7.2,42.86,13.455c.316.316.684.586,1.033.875Z",
    transform: "translate(84.805 0.001)",
    fill: "#111c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52908",
    "data-name": "Path 52908",
    d: "M55.6,29.768,66.838,18.51A31.064,31.064,0,0,1,74.6,32.242a33.564,33.564,0,0,1-7.264,30.766A34.757,34.757,0,0,1,37.151,75.931,35.925,35.925,0,0,1,4.272,46.053,35.016,35.016,0,0,1,29.347,6.266c9.771-2.731,18.87-.79,27.437,4.31,1.3.77,2.533,1.632,3.8,2.448a3.17,3.17,0,0,0,.329.178L49.954,24.136A19.043,19.043,0,0,0,24.1,29.5a18.858,18.858,0,0,0,26.457,25.97A19.031,19.031,0,0,0,55.6,29.768",
    transform: "translate(20.862 28.054)",
    fill: "#111c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52909",
    "data-name": "Path 52909",
    d: "M16.172,17.012l5.408,5.448,7.343-7.4a11.181,11.181,0,0,1-3.2,13.883A11.333,11.333,0,0,1,9.645,13.295,11.178,11.178,0,0,1,23.528,9.716Z",
    transform: "translate(41.774 48.16)",
    fill: "#111c44"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeDart);
export default __webpack_public_path__ + "static/media/ne-dart.0307a65f40c13afd1e40b3327052ab67.svg";
export { ForwardRef as ReactComponent };